import { MainTypesEnum } from '@pages/CalculatorPage/types';

export interface SalariedDirectorFieldsProps {
  applicantNumber: number;
  incomeType: MainTypesEnum;
  isTimeTradingMoreThanTwoYears: boolean;
}

export enum TimeTradingEnum {
  lessThanTwoYears = 'lessThanTwoYears',
  moreThanTwoYears = 'moreThanTwoYears',
}

export const TimeTradingLabels = {
  [TimeTradingEnum.lessThanTwoYears]: 'affordabilityCalculator.salariedDirector.timeTrading.lessTime',
  [TimeTradingEnum.moreThanTwoYears]: 'affordabilityCalculator.salariedDirector.timeTrading.moreTime',
};
